export default {"src":"/_next/static/media/icon-point.1da0c5ed.svg","height":20,"width":19};